import {FC} from "react";
import styled from "styled-components";
import { Colors, HintTooltip, Tooltip } from "@brg/ui";
import { PlaceItem } from "./PlaceIconComponent";
import { LayoutConst } from "core";
import { useHistory } from "react-router-dom";
import { AppTester } from "supporting";


const IconBottomSVG: FC<{width?: number, height?: number, fill?: string}> = ({width = 32, height = 9, fill = '#FEFEFE'}) => <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 7.38197V0H32V7.38197C32 8.12535 31.2177 8.60884 30.5528 8.27639L16.4472 1.22361C16.1657 1.08284 15.8343 1.08284 15.5528 1.22361L1.44721 8.27639C0.782313 8.60884 0 8.12535 0 7.38197Z" fill={fill}/>
</svg>

const PlaceBody = styled.div<{width: number, height: number, fill: string}>`
  background: ${p => p.fill};
  width: ${p => p.width}px;
  height: ${p => p.width + p.height}px;
  
  display: flex;
  justify-content: center;
  align-items: center;
  
  
  svg {
    width: ${p => p.width - 8}px!important;
    height: ${p => p.width - 8}px!important;
  }
`

const PlaceIconWrapper = styled.div<{width: number, height: number, fill: string}>`
  position: relative;
  z-index: 100;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.12));
  display: flex;
  flex-direction: column;
  border-radius: 1px 1px 0px 0px;
  
  svg {
    width: ${p => p.width}px;
    height: ${p => p.height}px;
    fill: ${p => p.fill};
  }
`

const PlaceIconTooltipContent = styled.div`
  display: flex;
  padding: 4px 16px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 1px;
  background: ${Colors.galBlack5};
  color: ${Colors.galBlack47};
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.12);
  white-space: nowrap;
  max-width: min(90vw, 700px);
  width: 100%;

  text-align: right;
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: -0.26px;
  transition: 0.1s;

  @media screen and (max-width: ${LayoutConst.screen.s}px) {
    display: none;
  }
`

export const WinnerCircle = styled.a<{
  place: number
}>`
  cursor: pointer;
  width: 24px;
  height: 24px;

  display: flex;
  padding: 4px;
  justify-content: center;
  align-items: center;
  border-radius: 50%;

  background-color: ${({place}) => (
    place === 1 ? Colors.uiYellowEnabled :
    place === 2 ? Colors.galBlack21 : Colors.labEvent
  )};
  color: ${Colors.galBlack100} !important;

  text-align: center;
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: -0.26px;

  :hover {
    border: 1px solid ${Colors.zelWhite47};
  }

`

export const PlaceIcon: FC<{width?: number, height?: number, fill?: string, placeItems?: PlaceItem[]}> = ({width = 32, height = 9, fill = '#FEFEFE', placeItems = []}) => {
  const isGeo = AppTester.isGeograffee();
  const isGeoDafes = AppTester.isGeoDafes();
  const history = useHistory();

  const handleBackToCompetition = () => {
    if(placeItems[0].competitionId){
      history.push(placeItems[0].competitionId);
    }
  };
  const baseStyle = { padding: '4px 8px' };
  const geoStyle = isGeo && !isGeoDafes ? { background: '#353A3E' } : isGeoDafes ? {background: '#E7E7E7', color: '#70706F'} : {};

  const combinedStyle = { ...baseStyle, ...geoStyle };
    return <PlaceIconWrapper width={width} height={height} fill={fill}>
        {placeItems.map((placeItem, index) => (
          <HintTooltip 
    // @ts-ignore
    customStyle={combinedStyle} text={placeItem.name || ""} closeToRightCorner>
            <PlaceBody width={width} height={height} fill={fill} key={index} onClick={handleBackToCompetition}><WinnerCircle place={placeItem.place}>{placeItem.place}</WinnerCircle></PlaceBody>
          </HintTooltip>
        ))}
        <IconBottomSVG width={width} height={height} fill={fill}/>
    </PlaceIconWrapper>
}import {FC} from "react";
import styled from "styled-components";
import { Colors, HintTooltip, Tooltip } from "@brg/ui";
import { PlaceItem } from "./PlaceIconComponent";
import { LayoutConst } from "core";
import { useHistory } from "react-router-dom";
import { AppTester } from "supporting";


const IconBottomSVG: FC<{width?: number, height?: number, fill?: string}> = ({width = 32, height = 9, fill = '#FEFEFE'}) => <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 7.38197V0H32V7.38197C32 8.12535 31.2177 8.60884 30.5528 8.27639L16.4472 1.22361C16.1657 1.08284 15.8343 1.08284 15.5528 1.22361L1.44721 8.27639C0.782313 8.60884 0 8.12535 0 7.38197Z" fill={fill}/>
</svg>

const PlaceBody = styled.div<{width: number, height: number, fill: string}>`
  background: ${p => p.fill};
  width: ${p => p.width}px;
  height: ${p => p.width + p.height}px;
  
  display: flex;
  justify-content: center;
  align-items: center;
  
  
  svg {
    width: ${p => p.width - 8}px!important;
    height: ${p => p.width - 8}px!important;
  }
`

const PlaceIconWrapper = styled.div<{width: number, height: number, fill: string}>`
  position: relative;
  z-index: 100;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.12));
  display: flex;
  flex-direction: column;
  border-radius: 1px 1px 0px 0px;
  
  svg {
    width: ${p => p.width}px;
    height: ${p => p.height}px;
    fill: ${p => p.fill};
  }
`

const PlaceIconTooltipContent = styled.div`
  display: flex;
  padding: 4px 16px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 1px;
  background: ${Colors.galBlack5};
  color: ${Colors.galBlack47};
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.12);
  white-space: nowrap;
  max-width: min(90vw, 700px);
  width: 100%;

  text-align: right;
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: -0.26px;
  transition: 0.1s;

  @media screen and (max-width: ${LayoutConst.screen.s}px) {
    display: none;
  }
`

export const WinnerCircle = styled.a<{
  place: number
}>`
  cursor: pointer;
  width: 24px;
  height: 24px;

  display: flex;
  padding: 4px;
  justify-content: center;
  align-items: center;
  border-radius: 50%;

  background-color: ${({place}) => (
    place === 1 ? Colors.uiYellowEnabled :
    place === 2 ? Colors.galBlack21 : Colors.labEvent
  )};
  color: ${Colors.galBlack100} !important;

  text-align: center;
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: -0.26px;

  :hover {
    border: 1px solid ${Colors.zelWhite47};
  }

`

export const PlaceIcon: FC<{width?: number, height?: number, fill?: string, placeItems?: PlaceItem[]}> = ({width = 32, height = 9, fill = '#FEFEFE', placeItems = []}) => {
  const isGeo = AppTester.isGeograffee();
  const isGeoDafes = AppTester.isGeoDafes();
  const history = useHistory();

  const handleBackToCompetition = () => {
    if(placeItems[0].competitionId){
      history.push(placeItems[0].competitionId);
    }
  };
  const baseStyle = { padding: '4px 8px' };
  const geoStyle = isGeo && !isGeoDafes ? { background: '#353A3E' } : isGeoDafes ? {background: '#E7E7E7', color: '#70706F'} : {};

  const combinedStyle = { ...baseStyle, ...geoStyle };
    return <PlaceIconWrapper width={width} height={height} fill={fill}>
        {placeItems.map((placeItem, index) => (
          <HintTooltip 
    // @ts-ignore
    customStyle={combinedStyle} text={placeItem.name || ""} closeToRightCorner>
            <PlaceBody width={width} height={height} fill={fill} key={index} onClick={handleBackToCompetition}><WinnerCircle place={placeItem.place}>{placeItem.place}</WinnerCircle></PlaceBody>
          </HintTooltip>
        ))}
        <IconBottomSVG width={width} height={height} fill={fill}/>
    </PlaceIconWrapper>
}